import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../shared/global.service';
import { CartService } from '../shared/cart/cart.service';

@Component({
  selector: 'app-timeExpiration',
  templateUrl: './timeExpiration.component.html',
  styleUrls: ['./timeExpiration.component.scss']
})

export class TimeExpirationComponent implements OnInit {
  constructor(
    private _router: Router,
    private _globalService: GlobalService,
    private _cartService: CartService) { }

  async ngOnInit() {
    this._globalService.stopTimer();
    this._globalService.clean();
    this._cartService.clearCart();
  }

  bookNow() {
    this._router.navigate(['../home'], {queryParamsHandling: 'merge', queryParams: { isAtmPayment: null }});
  }
}
